import * as styles from './styles';
import useTimer from '@hooks/common/util/useTimer';
import FocusableMicrophone from '../FocusableMicrophone';
import { useVideoCallContext } from '@context/VideoCall';
import { END_CALL_KEY } from '../../../focuskey';
import FocusableIconButton from '@components/FocusableIconButton';
const VideoFooter = () => {
  const { formattedTime } = useTimer();
  const { audioState, setAudioState, openTreatmentEndModal, subscriberConnected } =
    useVideoCallContext();

  return (
    <div css={styles.container}>
      <div css={styles.microphoneWrapper}>
        <FocusableMicrophone
          off={!audioState}
          onEnterPress={() => setAudioState((prev) => !prev)}
        />
      </div>
      <div css={styles.timeTextWrapper}>
        <p css={styles.timeText}>
          {subscriberConnected ? formattedTime : '연결중입니다.'}
        </p>
      </div>
      <div css={styles.bottomRightContainer}>
        <div css={styles.buttonContainer}>
          <FocusableIconButton
            iconType="power"
            focusKey={END_CALL_KEY}
            onEnterPress={openTreatmentEndModal}
          >
            진료 종료하기
          </FocusableIconButton>
        </div>
      </div>
    </div>
  );
};

export default VideoFooter;
